import useApi from 'lib/effects/api'

const useSaveProbateCaseField = ({
  probateCaseId,
}: {
  probateCaseId: number
}) => {
  const [
    { data: updatedProbateCase, isLoading: isCaseUpdating, errors: caseErrors },
    updateProbateCase,
  ] = useApi()

  const saveProbateCaseField = ({
    name,
    value,
  }: {
    name: string
    value: unknown
  }) => {
    updateProbateCase({
      url: `/api/probate-cases/${probateCaseId}`,
      method: 'PATCH',
      data: {
        data: {
          type: 'probate_cases',
          id: probateCaseId,
          attributes: { [name]: value || null },
        },
      },
    }).catch(() => undefined)
  }

  return {
    saveProbateCaseField,
    updatedProbateCase,
    isCaseUpdating,
    caseErrors,
  }
}

export default useSaveProbateCaseField
